import React, { useState } from "react";
import { PayPalScriptProvider, PayPalButtons, usePayPalScriptReducer } from "@paypal/react-paypal-js";
import "./styles/Donations.scss";

// Create a loading component for PayPal
function PayPalButtonWrapper({ donationAmount, handleApprove }) {
  const [{ isPending }] = usePayPalScriptReducer();

  return (
    <div className="paypal-button">
      {isPending ? (
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Loading payment options...</p>
        </div>
      ) : (
        <PayPalButtons
          key={donationAmount}
          style={{
            layout: "vertical",
            color: "gold",
            shape: "pill",
            label: "donate",
            tagline: false,
            height: 55,
          }}
          createOrder={(data, actions) => {
            if (donationAmount <= 0 || isNaN(donationAmount)) {
              alert("Please select or enter a valid donation amount.");
              return;
            }

            return actions.order.create({
              purchase_units: [
                {
                  amount: {
                    value: donationAmount.toFixed(2),
                  },
                  description: "Donation to Dels Music Foundation",
                  shipping_preference: "NO_SHIPPING",
                },
              ],
            });
          }}
          onApprove={(data, actions) => {
            return actions.order.capture().then((details) => {
              handleApprove(details.id);
            });
          }}
          onError={(err) => {
            console.error("PayPal Checkout Error:", err);
            alert("An error occurred during the donation process.");
          }}
        />
      )}
    </div>
  );
}

export default function Donations() {
  const [donationAmount, setDonationAmount] = useState(20);

  const handleApprove = (orderID) => {
    alert(`Thank you for your donation! Your Order ID is ${orderID}.`);
  };

  return (
    <PayPalScriptProvider
      options={{
        "client-id":
          "Ae0qriJgxf-LLzZ_fHPA2wLK8-b3P1m3vqGUEEqGVvqQqznvwUy0gvHc2NdzRNAgN_bYYEj1J7srafuo",
        currency: "USD",
        "disable-funding": "paylater",
      }}
    >
      <div className="donations">
        <h1>Support Our Cause</h1>
        <p>
          Your donations help us continue providing access to music education
          and resources to underserved communities.
          <span className="fix-clipping"> Support the cause today!</span>
        </p>

        <div className="donation-form">
          <h2>Make a Donation</h2>

          <div className="amount-options">
            <button
              className={donationAmount === 20 ? "active" : ""}
              onClick={() => setDonationAmount(20)}
            >
              $20
            </button>
            <button
              className={donationAmount === 50 ? "active" : ""}
              onClick={() => setDonationAmount(50)}
            >
              $50
            </button>
            <button
              className={donationAmount === 100 ? "active" : ""}
              onClick={() => setDonationAmount(100)}
            >
              $100
            </button>
            <button
              className={donationAmount === 500 ? "active" : ""}
              onClick={() => setDonationAmount(500)}
            >
              $500
            </button>
            <input
              type="number"
              placeholder="Other amount"
              value={donationAmount}
              onChange={(e) =>
                setDonationAmount(
                  e.target.value > 0 ? parseFloat(e.target.value) : 0
                )
              }
            />
          </div>

          <p>Selected Donation Amount: ${donationAmount}</p>

          <PayPalButtonWrapper 
            donationAmount={donationAmount} 
            handleApprove={handleApprove} 
          />
        </div>

        <div className="send-check">
          <h2>Prefer to Send a Check?</h2>
          <p>
            You can send a check made payable to:
            <br />
            <strong>Dels Music Foundation</strong>
            <br />
            Address: 3704 16th Ave E., Palmetto, FL 34221
            <span className="fix-clipping"> Thank you for your support!</span>
          </p>
        </div>
      </div>
    </PayPalScriptProvider>
  );
}
